import { generateContext } from '../../utils'
import { MLPResult } from './MLPStore'

interface Violator {
    parking_results_uuid: string
    plate: string
    parking_lot: string
    device_id_in: string
    device_id_out: string
    device_name_in: string
    device_name_out: string
    timestamp_in: string
    timestamp_out: string
    signed_url_in_render: string
    signed_url_out_render: string
    signed_url_in_lp: string
    signed_url_out_lp: string
    lpness_in: number | null
    lpness_out: number | null
    lpr_in: number | null
    lpr_out: number | null
}

interface SimilarDetection {
    detection_uuid: string
    plate: string
    device_id: string
    device_name: string
    category: string
    direction: string
    timestamp: string
    signed_url_render: string
    signed_url_lp: string
    lpness: number | null
    lpr: number | null
}

export interface MLPCase {
    offender: Violator
    similar_detections: SimilarDetection[]
}

export type MLPList = MLPCase[]
export type MLPBatches = MLPCase[][]
export enum MLPCategory {
    MLP = 'mlp',
    Violator = 'confirmed_violator'
}
export interface IMLPContext {
    mlpBatches: MLPBatches
    pushCheckedMlpsHandler: (checkedMlps: MLPResult[], callback: () => void) => void
    loadingPushCheckedMlps: boolean
}
const [MLPContext, MLPProvider] = generateContext<IMLPContext>()
export { MLPContext, MLPProvider }
